import * as React from "react";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import DropdownApi from "../../../components/DropdownApi";
import { siteChemicalAdd, siteChemicalUpdate } from "../../../service/siteService";
import { Grid } from "@mui/material";
import { useToast } from "../../../context/ToastContext";
import { useState } from "react";
import useApiService from "../../../hooks/useApiService";
import { useSiteContext } from "../../../context/siteContext";
import { Chemical } from "../../../models/chemical.interface";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Equipment } from "../../../models/equipment.interface";

export default function SiteChemicalAdd(modalProps: any) {
  const { site, setSite } = useSiteContext();

  const record = modalProps.record;
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [chemicalData, setChemicalData] = useState<Chemical[]>([]);
  const [selectedChemicals, setSelectedChemicals] = useState<Chemical[]>([]);
  const [rowClick, __] = useState(true);

  function handleSelectionChange(e: any) {
    setSelectedChemicals(e.value as Chemical[]);
  }

  const { loading: loadingChemicals } = useApiService<Chemical[]>({
    url: "chemical",
    apiName: "core",
    method: "GET",
    onSuccess: data => {
      const availableChemicals = data.filter(
        chemical => !modalProps?.chemicalIds.includes(chemical.id)
      );
      setChemicalData(availableChemicals);
    },
  });

  const { loading: addingChemical, fetchData: addChemical } = useApiService<
    {
      active: boolean;
      equipment: string;
      id: number;
      site: string;
    }[]
  >({
    fetchOnMount: false,
    url: "site-chemical",
    apiName: "core",
    method: "POST",
    onSuccess: () => {
      toast("success", "Chemical Added Successfully");
      modalProps.setReload?.(!modalProps.reload);
      modalProps.setVisible?.(false);

      if (modalProps.callback) modalProps.callback();
    },
    onError: error => {
      toast("error", error.message || "Error adding chemical");
    },
  });

  async function handleSave(selectedData: Chemical[]) {
    const payload: { chemical: string[] } = {
      chemical: selectedData.map(chemical => chemical.id),
    };
    await addChemical({
      payload: payload,
    });
  }

  return (
    <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, overflowY: "auto", padding: "0 1rem 1rem" }}>
        {/*@ts-ignore*/}
        <DataTable
          value={chemicalData ?? []}
          selectionMode={rowClick ? "multiple" : null}
          selection={selectedChemicals}
          onSelectionChange={(e: any) => {
            handleSelectionChange(e);
          }}
          dataKey={"id"}
          tableStyle={{ minWidth: "50rem" }}
          loading={loadingChemicals}
        >
          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
          <Column header={"Name"} field={"name"} style={{ minWidth: "12rem" }} />
          <Column header={"Description"} field={"description"} />
          <Column header={"Type"} field={"type"} />
          <Column header={"Quantity"} field={"quantity"} />
          <Column header={"Units"} field={"units"} />
        </DataTable>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          gap: "1rem",
          background: "white",
          paddingTop: "1rem",
          borderTop: "1px solid #e5e7eb",
          flexShrink: 0,
        }}
      >
        <Button
          label="Cancel"
          severity="secondary"
          outlined
          onClick={() => {
            modalProps.setVisible?.(false);
          }}
          disabled={addingChemical}
        />

        <Button
          label={"Add Chemicals"}
          color={"primary"}
          loading={addingChemical}
          disabled={loadingChemicals || addingChemical}
          onClick={async () => {
            await handleSave(selectedChemicals);
          }}
        />
      </div>
    </div>
    // <React.Fragment>
    //   <Grid container spacing={2}>
    //     <Grid item xs={12}>
    //       <DropdownApi
    //         apiPath="chemical"
    //         optionLabel="name"
    //         optionValue="id"
    //         label="Chemical"
    //         selectedData={chemical}
    //         setSelectedData={setChemical}
    //       />
    //     </Grid>
    //   </Grid>
    //   <CardOverflow
    //     style={{ width: "100%" }}
    //     sx={{ borderTop: "1px solid", borderColor: "divider" }}
    //   >
    //     <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
    //       <Button
    //         type="button"
    //         icon="pi pi-save"
    //         label="Save"
    //         className="p-button-outlined"
    //         size="small"
    //         style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
    //         onClick={() => ChemicalAdd()}
    //         loading={loading}
    //         disabled={loading}
    //       />
    //     </CardActions>
    //   </CardOverflow>
    // </React.Fragment>
  );
}
